import { TranslationAboutPage, TranslationHomePage, TranslationParticipantPage } from 'pages';

const pt = {
  ...TranslationAboutPage,
  ...TranslationHomePage,
  ...TranslationParticipantPage,
};

export default pt;
